export default "__VITE_ASSET__CX04id1G__"